<mat-card appearance="outlined">
  <span mat-line>{{'NEW_SOFTWARE_UPDATE' | translate}}</span><br>
  <span mat-line>{{'PLEASE_CLICK' | translate}} <strong class="update-button blinking" (click)="update($event)">{{'HERE' | translate}}</strong> {{'TO_UPDATE' | translate}}</span>
</mat-card>
